export const REACT_QUILL_MODULE_TOOLBAR = [
  [{ size: [] }],
  [
    {
      align : []
    }
  ],
  [ 'bold', 'italic', 'underline', 'strike', 'blockquote', 'code'],
  [
    { list: 'ordered' },
    { list: 'bullet' },
    { indent: '-1' },
    { indent: '+1' }
  ],
  ['link', 'image'],
  ['clean']
]

export const REACT_QUILL_FORMATS = [
  'header',
  'size',
  'align',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'code',
  'list',
  'indent',
  'link',
  'image'
]